import { CoreType, GenericTableSchemaInterface, UserVars, StoreVars } from '../../swivl-lib'
import { BotVariables } from '@swivl/swivl-worksheets-lib'

export const Discounts00Table: GenericTableSchemaInterface = {
  id: 'discounts-00',
  name: 'Discounts 00',
  description: 'This table contains data regarding discounts.',
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: 'Operator Name',
      variable: BotVariables.Bot_Operator_Name
    },
    c02: {
      name: 'Facility ID',
      variable: StoreVars.StoreId
    },
    c03: {
      name: 'Intent Start'
    },
    c04: {
      name: 'General Start'
    },
    c05: {
      name: 'Custom Start'
    },
    c06: {
      name: 'Military Start'
    },
    c07: {
      name: 'Student Start'
    },
    c08: {
      name: 'Senior Start'
    },
    c09: {
      name: 'Long Term Lease Start'
    }
  }
}
